import {
  afterRenderEffect,
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ModalService } from '@features/modals/services/modal.service';
import { FormFieldComponent } from '@core/components/form-field/form-field.component';
import { AdminLimit } from '@features/admin/admin-limits/admin-limit.interface';
import { AdminLimitService } from '@features/admin/admin-limits/admin-limit.service';

@Component({
  selector: 'app-admin-limit-modal',
  imports: [FormFieldComponent, ReactiveFormsModule],
  templateUrl: './admin-limit-modal.component.html',
  styleUrl: './admin-limit-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    class: 'modal-container flex flex-col',
  },
})
export class AdminLimitModalComponent {
  limit = input.required<AdminLimit>();

  private readonly toastrService = inject(ToastrService);
  private readonly modalService = inject(ModalService);
  public readonly adminLimitService = inject(AdminLimitService);

  skinName = new FormControl<string>(
    {
      value: '',
      disabled: true,
    },
    [Validators.required]
  );
  limitValue = new FormControl<number | null>(null, [Validators.required]);

  limitForm = new FormGroup({
    skinName: this.skinName,
    limitValue: this.limitValue,
  });

  constructor() {
    afterRenderEffect(() => {
      this.skinName.setValue(this.limit().name);
      this.limitValue.setValue(this.limit().limit);
    });
  }

  async onSubmit() {
    this.limitForm.markAllAsTouched();

    if (!this.limitForm.valid) {
      this.toastrService.error('Form is not valid. Please check the inputs.');
      return;
    }

    const skinName = this.limitForm.get('skinName')?.value;
    const limitValue = this.limitForm.get('limitValue')?.value;

    if (!limitValue) {
      this.toastrService.error('Limit is required');
      return;
    }

    if (!skinName) {
      this.toastrService.error('Skin name is required');
      return;
    }

    if (!this.limitForm.valid) {
      this.toastrService.error('Form is not valid. Please check the inputs.');
      return;
    }

    try {
      await this.adminLimitService.modifyLimit(skinName, limitValue);
      this.toastrService.success('Limit has been modified successfully');
      this.modalService.close();
    } catch (error) {
      this.toastrService.error('Failed to modify limit. Please try again.');
    }
  }
}
